// Module
var code = "<div class=\"container-lg mt-5 pb-7\">\n  <div class=\"display-5 text-center\">Contact Information</div>\n</div>\n";
// Exports
export default code;